import { useCopyToClipboard } from '@hooks/useCopyToClipboard'
import { Button, Spacer, Spreader, Text } from '@ui-kit'
import { Fragment } from 'react'
import { Column, Row } from 'simple-flexbox'

import styles from './Fields.module.scss'

export const BaseField = ({
  label,
  value,
  withCopy = true
}: {
  label: string
  value: string
  withCopy?: boolean
}) => {
  const [handleCopy] = useCopyToClipboard(value)

  return (
    <Column>
      <div className={styles.label}>
        <Text size={14} color='neutral-6' lineHeight='normal'>
          {label}
        </Text>
      </div>

      <Row className={styles.field}>
        <Text size={16} color='neutral' className={styles.value}>
          {value || '-'}
        </Text>

        {withCopy && (
          <Fragment>
            <Spreader spread={10} />

            <Button
              className={styles.button}
              size={14}
              variant='text-neutral'
              icon='icon-file-copy'
              onClick={handleCopy}
            />
          </Fragment>
        )}
      </Row>

      <Spacer space={10} />
    </Column>
  )
}
